// select-size.js
// 1. On page load: if ?variant= in URL honour that size visually; else select first in-stock (fallback: first size)
// 2. ATC submit: allow through if hidden select[name="id"] has a value (handles themes where visual swatches don't check radios)
document.addEventListener('DOMContentLoaded', function() {

  // --- AUTO-SELECT DEFAULT SIZE ON PAGE LOAD ---
  var sizeFieldset = document.querySelector('.variant-input-wrap[data-handle="size"]');
  if (sizeFieldset) {
    var sizeInputs = Array.from(sizeFieldset.querySelectorAll('input[type="radio"]'));
    if (sizeInputs.length > 0) {

      var toSelect = null;

      // Check if a specific variant is already in the URL (ads, emails, wishlist, returns etc.)
      var urlParams = new URLSearchParams(window.location.search);
      var urlVariantId = urlParams.get('variant');

      if (urlVariantId) {
        // Find the hidden select option that matches the URL variant and get its size value
        var hiddenSelect = document.querySelector('select[name="id"]');
        if (hiddenSelect) {
          var matchingOption = Array.from(hiddenSelect.options).find(function(opt) {
            return opt.value === urlVariantId;
          });
          if (matchingOption) {
            // Extract size value (option text is e.g. "M - $220.00 AUD")
            var sizeValue = matchingOption.text.split(' - ')[0].trim();
            toSelect = sizeInputs.find(function(input) {
              return input.value === sizeValue;
            });
          }
        }
      }

      // No URL variant (or couldn't match it) — fall back to first in-stock size
      if (!toSelect) {
        toSelect = sizeInputs.find(function(input) {
          var label = sizeFieldset.querySelector('label[for="' + input.id + '"]');
          return label && !label.classList.contains('disabled');
        });
      }

      // Last resort fallback: first size regardless of stock
      if (!toSelect) {
        toSelect = sizeInputs[0];
      }

      if (toSelect) {
        toSelect.click(); // triggers theme's variant change handler (ATC state, notify me, hidden select)
      }
    }
  }

  // --- ATC SUBMIT VALIDATION ---
  var productForms = document.querySelectorAll('form[action="/cart/add"], form[action*="/cart/add"]');
  productForms.forEach(function(form) {
    form.addEventListener('submit', function(event) {
      if (!form.offsetParent) return; // skip hidden forms
      var submitter = event.submitter || document.activeElement;
      if (submitter && submitter.classList && submitter.classList.contains('variant-button')) return;

      var sizeOptions = Array.from(document.querySelectorAll('input[type="radio"][name="Size"], input[type="radio"][name="size"]'));
      if (sizeOptions.length === 0) return;

      var visibleSizeOptions = sizeOptions.filter(function(input) { return input.offsetParent !== null; });
      var optionsToCheck = visibleSizeOptions.length > 0 ? visibleSizeOptions : sizeOptions;
      var sizeSelected = optionsToCheck.some(function(input) { return input.checked; });

      // Fallback: check hidden select[name="id"] if no radio is checked
      if (!sizeSelected) {
        var hiddenSelect = form.querySelector('select[name="id"]');
        if (hiddenSelect && hiddenSelect.value && hiddenSelect.value !== '') {
          sizeSelected = true;
        }
      }

      if (sizeSelected) {
        var existingError = document.getElementById('select-size-error');
        if (existingError) existingError.textContent = '';
      } else {
        event.preventDefault();
        event.stopImmediatePropagation();
        var errorEl = document.getElementById('select-size-error');
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.id = 'select-size-error';
          errorEl.style.cssText = 'color:#e74c3c;font-size:13px;margin:8px 0;font-weight:500;';
          var atcBtn = form.querySelector('.add-to-cart:not(.variant-button)');
          if (atcBtn && atcBtn.parentNode) {
            atcBtn.parentNode.insertBefore(errorEl, atcBtn);
          } else {
            var sizeWrapper = document.querySelector('.variant-input-wrap, .selector-wrapper');
            if (sizeWrapper && sizeWrapper.parentNode) sizeWrapper.parentNode.insertBefore(errorEl, sizeWrapper.nextSibling);
          }
        }
        errorEl.textContent = 'Please select a size before adding to cart';
        clearTimeout(errorEl._hideTimeout);
        errorEl._hideTimeout = setTimeout(function() { errorEl.textContent = ''; }, 3000);
      }
    }, true);
  });
});